import React from 'react'
import { connect} from 'react-redux'
import { withRouter, Link } from 'react-router-dom'
import GetAllFoodItems from './GetAllFoodItems'
// import AddFoodItem from './AddFoodItem'


const VolunteerDashboard = (props) => {
    const {loggedUser} = props
    console.log(loggedUser)
    return (
        <div>
            <h1>Dashboard</h1>
            <p>Current User: {loggedUser.username}</p>
            <p>Current Address: {loggedUser.address}</p>
            <p>Current Contact #: {loggedUser.phone}</p>
            <p>Current Contact Email: {loggedUser.email}</p>
            <GetAllFoodItems />
            {/* <AddFoodItem /> */}
            <br /><br />
            <Link className="abutton" to='/updateFoodItem'>Claim/Update/Delete a Food Item</Link>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {loggedUser: state.loggedUser}
}

export default withRouter(
    connect(
        mapStateToProps,
    )(VolunteerDashboard)
)
